import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

export const formattedDate = (date: any) => {
  if (!date || date == "") return "";
  return dayjs(date).format("DD-MM-YYYY");
  //   return dayjs(date).format("DD MMMM YYYY");
};

export const formatSlashDate = (date: any) => {
  if (!date || date == "") return "";
  return dayjs(date, "DD/MM/YYYY").format("DD-MM-YYYY");
};

// dd month_name year - format
dayjs.extend(customParseFormat);

export function formatDateDDMMMMYYYY(date: string): string {
  const parsed = dayjs(date, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"], true);

  if (!date || !parsed.isValid()) return "";
  return parsed.format("D MMMM YYYY");
}
